import { render, staticRenderFns } from "./CustomizableColor.vue?vue&type=template&id=e2915d2c"
import script from "./CustomizableColor.vue?vue&type=script&lang=js"
export * from "./CustomizableColor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports